<template>
    <div class="openactionsstatus">
        <b-card :key="pstates" _title="Actions - Status">
            <b-row v-for="r in rows" :key="r" class="stati">
                <b-col cols="6">
                    <template v-if="states.length">
                        <div class=pallino :style="`width: 20px;height: 20px;background-color: ${states[r].color};border-radius: 50%;margin:10px;border: 2px solid black;`"></div>
                        <div class="descr">{{ states[r].descr }}</div>
                        <div class="num">{{ states[r].k }}</div>
                    </template>
                    <hr>
                </b-col>
                <b-col cols="6">
                    <template v-if="states.length">
                        <div class=pallino :style="`width: 20px;height: 20px;background-color: ${states[r + 1].color};border-radius: 50%;margin:10px;border: 2px solid black;`"></div>
                        <div class="descr">{{ states[r + 1].descr }}</div>
                        <div class="num">{{ states[r + 1].k }}</div>
                    </template>
                    <hr>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { API } from "@/api.js";

export default {
    data: function () {
        return {
            states: [],
            rows: [0, 2],
            issue: null,
        };
    },
    name: "OpenActionsStatus",
    async mounted() {
        this.issue = this.$store.getters.issue
        console.log("issue",this.issue)
        await this.getActionsStates()
        console.log("mounted states:", this.states);
    },
    computed: {
        pstates() {
            return this.$store.getters.pstates
        },
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
    },
    watch: {
        async pstates() {
            this.states = await API.actionStates(this.issue ? this.issue.id : null, this.section);
        }
    },
	methods: {
        async getActionsStates(){
            this.states = await API.actionStates(this.issue ? this.issue.id : null, this.section);
        }
    },
};
</script>

<style scoped>
div.pallino {
    float: left;
}

div.descr {
    float: left;
    position: relative;
    top: 7px;
    margin-left: 20px;
}

div.num {
    float: right;
    position: relative;
    top: 7px;
    font-weight: 700;
}

hr {
    position: relative;
    top: 20px;
}
</style>
